<template>
  <div class="container">
    <div class="invite_cover">
      <img class="invite_cover_bg" src="../../assets/fx/invite_cover.png" />
      <img class="invite_cover_icon" src="../../assets/fx/logo_home.png" />
      <div class="invite_cover_rule">邀请规则</div>
      <div class="invite">
        
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {

      }
    },
    created() { },
    activated() { },
    watch: { },
    mounted() { },
    methods: {

    }
  }
</script>

<style lang="less" scoped="scoped">
  @vm_base: 1/750*100vw;
  .invite_cover{
    width:100%;
    position: relative;
    border: 1*@vm_base solid red;
    .invite_cover_bg{
      width: 100%;
    }
    .invite_cover_icon{
      position: absolute;
      top: 0;
      left: 0;
      width: 115*@vm_base;
      margin-top: 20*@vm_base;
      margin-left: 30*@vm_base;
    }
    .invite_cover_rule{
      position: absolute;
      top: 0;
      right: 0;
      margin-top: 80*@vm_base;
      background: rgba(255, 255, 255, 0.8);
      box-shadow: 0*@vm_base 0*@vm_base 10*@vm_base 0*@vm_base rgba(0, 0, 0, 0.1);
      border-radius: 10*@vm_base 0*@vm_base 0*@vm_base 10*@vm_base;
      border: 1*@vm_base solid #E7E7E7;
      font-size: 24*@vm_base;
      font-weight: 400;
      color: #030303;
      line-height: 1;
      padding: 16*@vm_base 12*@vm_base 16*@vm_base 28*@vm_base;
    }
  }
</style>



// WEBPACK FOOTER //
// src/fxviews/fxindex/fxindex.vue